import { render, staticRenderFns } from "./QuizEventCard.vue?vue&type=template&id=5fc4bf72&scoped=true&"
import script from "./QuizEventCard.vue?vue&type=script&lang=ts&"
export * from "./QuizEventCard.vue?vue&type=script&lang=ts&"
import style0 from "./QuizEventCard.vue?vue&type=style&index=0&id=5fc4bf72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc4bf72",
  null
  
)

export default component.exports